<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Admin</h3>
          <p class="page-head__sub">Manage administrator accounts and permissions.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill">
            <i class="fa fa-shield"></i> {{ admins?.length }} admins
          </span>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="content-body">
        <!-- Revenue, Hit Rate & Deals -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header card-toolbar">
                <h4 class="card-toolbar__title">
                  <i class="fa fa-shield"></i> Admin Accounts
                  <span class="count-pill">{{ admins?.length }}</span>
                </h4>
                <div class="card-toolbar__actions">
                  <app-admin-filter (closeFilter)="onCloseFilter($event)"
                    (filteredTransactions)="getFilteredTransactions($event)"
                  (onFormReset)="getAll()"></app-admin-filter>
                  <app-admin-modal></app-admin-modal>
                </div>
              </div>
              <div class="card-content">
                <div class="hover">
                  @if (admins?.length > 0) {
                    <table class="table  table-de mb-0">
                      <thead>
                        <tr>
                          <!-- <th>
                          <fieldset>
                            <div class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                name="customCheck"
                                id="customCheck"
                                aria-label="Select all admins"
                                />
                              <label
                                class="custom-control-label"
                                for="customCheck"
                              ></label>
                            </div>
                          </fieldset>
                        </th> -->
                        <th (click)="sortOrders('name')" tabindex="0" (keydown.enter)="sortOrders('name')"
                          (keydown.space)="sortOrders('name')">
                          FullName
                          @if (sortType === 'name' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'name' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('agent')" tabindex="0" (keydown.enter)="sortOrders('agent')"
                          (keydown.space)="sortOrders('agent')">
                          IMTO
                          @if (sortType === 'agent' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'agent' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('email')" tabindex="0" (keydown.enter)="sortOrders('email')"
                          (keydown.space)="sortOrders('email')">
                          Email
                          @if (sortType === 'email' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'email' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('phone_number')" tabindex="0"
                          (keydown.enter)="sortOrders('phone_number')" (keydown.space)="sortOrders('phone_number')">
                          Phone No
                          @if (sortType === 'phone_number' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'phone_number' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('country')" tabindex="0" (keydown.enter)="sortOrders('country')"
                          (keydown.space)="sortOrders('country')">
                          State/Country
                          @if (sortType === 'country' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'country' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('created_at')" tabindex="0" (keydown.enter)="sortOrders('created_at')"
                          (keydown.space)="sortOrders('created_at')">
                          Date Added
                          @if (sortType === 'created_at' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'created_at' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (admin of admins | paginate : config; track admin) {
                        <tr class="pull-up">
                          <!-- <td>
                          <fieldset>
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input" name="customCheck"
                                id="customCheck{{ admin?.id }}"
                                [attr.aria-label]="'Select ' + (admin?.name || 'admin')" />
                              <label class="custom-control-label" for="customCheck{{ admin?.id }}"></label>
                            </div>
                          </fieldset>
                        </td> -->
                        <td>
                          <a [routerLink]="['/admin', $safeNavigationMigration(admin?.slug)]">{{
                            admin?.name
                          }}</a>
                        </td>
                        @if (admin?.permission === 'admin') {
                          <td>
                            <a [routerLink]="['/agent', $safeNavigationMigration(admin?.agent?.slug)]">{{
                              admin?.agent?.name
                            }}</a>
                          </td>
                        }
                        @if (admin?.permission === 'super_admin') {
                          <td>
                            <button class="btn btn-outline-info round">
                              SUPER ADMIN
                            </button>
                          </td>
                        }
                        <td>{{ admin?.email }}</td>
                        <td>{{ admin?.phone_number }}</td>
                        <td>
                          {{ admin?.city?.name }}/{{ admin?.country?.name }}
                        </td>
                        <td>{{ $safeNavigationMigration(admin?.created_at) | date }}</td>
                        <td>
                          <div class="form-group mtonClick-1">
                            <ui-switch (change)="onClick($event, $safeNavigationMigration(admin?.slug))"
                            [checked]="getStatus(+$safeNavigationMigration(admin?.status))"></ui-switch>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
              @if (admins?.length > 10) {
                <div style="text-align: center; width: 100%">
                  <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
                </div>
              }

              @if (admins?.length === 0) {
                <div class="empty-state">
                  {{ emptyAdminMessage }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
<app-bottombar></app-bottombar>